class ExpandableCardGrid extends HTMLElement {
  constructor() {
    super();
    this.button = null;
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('[data-card-grid-toggle]');
    if (!this.button) return;
    this.button.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    if (this.button) this.button.removeEventListener('click', this.handleClick);
  }

  handleClick() {
    const items = this.querySelectorAll('[data-card-grid-item]');
    items.forEach((item) => {
      if (item.classList.contains('!hidden')) item.classList.remove('!hidden');
    });
    this.button.classList.add('!hidden');
  }
}

if (!customElements.get('expandable-card-grid')) {
  customElements.define('expandable-card-grid', ExpandableCardGrid);
}
